import { render, staticRenderFns } from "./SubscribeEDM.vue?vue&type=template&id=55f9e78e&scoped=true"
import script from "./SubscribeEDM.vue?vue&type=script&lang=js"
export * from "./SubscribeEDM.vue?vue&type=script&lang=js"
import style0 from "./SubscribeEDM.vue?vue&type=style&index=0&id=55f9e78e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f9e78e",
  null
  
)

export default component.exports